<template>
  <div>
    <div class="row row-sm">
      <div class="col-3">
        <label for="">Client <span class="text-danger">*</span> </label>
        <select v-model="filter.customer_reference" class="form-select" required>
          <option selected value="">--</option>
          <option v-for="(customer, index) in customers" :key="index++" :value="customer.reference" :style="customer.blocked || customer.fullName.includes('Bloqué')
            ? { color: 'red' }
            : ''
            ">
            {{ customer.fullName }}
          </option>
        </select>
      </div>

      <div class="col">
        <label for="">Du <span class="text-danger">*</span> </label>
        <input v-model="filter.startDate" type="date" class="form-control" />
      </div>
      <div class="col">
        <label for=""> Au <span class="text-danger">*</span> </label>
        <input v-model="filter.endDate" type="date" class="form-control" />
      </div>

      <div class="col-3 ">
        <label for="">Mode de paiement</label>
        <select v-model="filter.paymentMethod" class="form-select">
          <option value="Espèce">Espèce</option>
          <option value="Virement bancaire">Virement bancaire</option>
          <option value="Chèque">Chèque</option>
          <option value="Effet">Effet</option>
        </select>
      </div>

      <div class="col-auto">
        <label for=""> </label>
        <button @click="toFilter(filter)" class="btn btn0 btn-secondary">
          <i class="bi bi-funnel"></i> Rechercher
        </button>
      </div>

      <div class="col-auto">
        <label for=""> </label>
        <button @click="print(filter)" class="btn btn-secondary">
          <i class="bi bi-printer"></i> Imprimer
        </button>
      </div>
    </div>
    <br />
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button @click="$router.push({ name: 'payments-customers-create' })" class="btn btn-primary">
          <i class="bi bi-plus-square"></i>
          Créer un nouveau paiement
        </button>
      </div>
    </div>
    <br />
    <vue-data-table v-if="payments.length" :headers="headers" :data="payments" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      filter: {
        startDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        paymentMethod: ""
      },
      headers: [
        { field: "reference", label: "Référence", class: "fw-bold" },
        { field: "order_reference", label: "BC", class: "fw-bold" },
        { field: "sale_reference", label: "BL", class: "fw-bold" },
        { field: "invoice_reference", label: "Facture", class: "fw-bold" },
        { field: "passPermit", label: "LP", class: "fw-bold" },
        { field: "customerFullName", label: "Client", class: "" },
        { field: "date", label: "Date", class: "" },
        { field: "paymentMethod", label: "Mode", class: "" },
        { field: "amount", label: "M. Payé", class: "" },
        { field: "remark", label: "Remarque", class: "" },
        { field: "userFullName", label: "Créer par", class: "" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-eye",
          class: "btn btn-info",
          action: (payment) => {
            this.$router.push({
              name: "payments-customers-details",
              params: { reference: payment.reference },
            });
          },
        },
      ],

      summableColumns: [
        { field: 'amount', class: 'text-primary' },
      ]
    };
  },
  computed: {
    ...mapGetters("payment", {
      payments: "getAll",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("auth", {
      userRole: "getUserRole",
    }),


  },
  mounted() {
    this.$store.dispatch("payment/getAll");
    this.$store.dispatch("customer/getAll");
  },
  methods: {
    async toFilter(data) {
      return await this.$store.dispatch("payment/filter", data);
    },
    async print(data) {
      await this.$store.dispatch("payment/print", data);
    },

    async refresh() {
      return await this.$store.dispatch("payment/getAll");
    },
  },
};
</script>
